import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

import '@src/css/bootstrap.scss';
import '@src/css/global.scss';

/**
 * ## ContentTitle
 *
 * Header Title Text
 * @param {string} title - Title text
 * @param {Component} subtitle - Component Subtitle
 */
export const ContentTitle = (props) => {
    const {
        as: As = 'h2',
        title,
        subContent,
    } = props;

    return (
        <Row className="section-header-container">
            <Col>
                <As className="text-center">
                    {SafelyRenderHtml(title)}
                </As>
                {subContent}
            </Col>
        </Row>
    );
};

ContentTitle.propTypes = {
    as: PropTypes.string,
    title: PropTypes.string,
    subContent: PropTypes.node,
};
